/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_DeleteInputs */

const cs_property_list_delete = /** @type {(inputs: Property_List_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat nemovitost`)
};

const en_property_list_delete = /** @type {(inputs: Property_List_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete property`)
};

/**
* | output |
* | --- |
* | "Delete property" |
*
* @param {Property_List_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_delete = /** @type {((inputs?: Property_List_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_delete(inputs)
	return cs_property_list_delete(inputs)
});